import { render, staticRenderFns } from "./CrewInfo.vue?vue&type=template&id=7e1ef0bc&scoped=true&"
import script from "./CrewInfo.vue?vue&type=script&lang=js&"
export * from "./CrewInfo.vue?vue&type=script&lang=js&"
import style0 from "./CrewInfo.vue?vue&type=style&index=0&id=7e1ef0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1ef0bc",
  null
  
)

export default component.exports